import {createContext} from "react";

import {defaultParams} from "../constants/defaults";
import {IPromptInternalProps, IPromptProps} from "../types/IPromptProps";

export const PromptContext = createContext<IPromptProps & IPromptInternalProps>(defaultParams);

export const PromptContextProvider = PromptContext.Provider;
import {createContext} from "react";

import {defaultParams} from "../constants/defaults";
import {IPromptInternalProps, IPromptProps} from "../types/IPromptProps";

export const PromptContext = createContext<IPromptProps & IPromptInternalProps>(defaultParams);

export const PromptContextProvider = PromptContext.Provider;
